import Vue from 'vue'
import App from './App.vue'

import 'jquery/dist/jquery'
import foundationCSS from 'foundation-sites/dist/css/foundation.min.css'
import foundationJS from 'foundation-sites/dist/js/foundation.min'
import router from './router'

import globalCSS from './main.scss'
import animateCSS from 'animate.css'
import VueObserveVisibility from 'vue-observe-visibility'
import i18n from './i18n'
import VueSmoothScroll from 'vue-smoothscroll'

Vue.use(VueObserveVisibility)
Vue.use(VueSmoothScroll)
Vue.config.productionTip = false

new Vue({
  router,
  globalCSS,
  animateCSS,
  foundationCSS,
  foundationJS,
  i18n,
  render: h => h(App)
}).$mount('#app')
